/* components/video_content.js */

/* Copyright 2020 - present Tikkl, Inc. */

/*
modification history
--------------------
01d,27feb26,mno  spacing adjustments.
01c,29may25,mno  updated class names for video; fadeIn; added text content.
01b,30aug22,mno  named exports.
01a,08oct20,mno  created.
    20jul22,mno  cleanup.
*/
import React from 'react';
import VideoPlayer from 'react-player';
import classNames from 'classnames';
import isPresent from '../lib/is_present';
import Markdown from './markdown';

const getAlignCx = (align) => {
  switch(align) {
    case 'center':  return 'has-text-centered';
    case 'left':    return 'has-text-left';
    case 'right':   return 'has-text-right';
    case 'justify': return 'has-text-justified';
    default:        return '';
  }
}

const getSizeCx = (size) => {
  if (isPresent(size)) return `is-${size}`;
  return '';
}

const VideoContent = (props) => {
  const {
    containerSize, containerAlign,
    size, url, caption, title, subtitle, description,
    className, align, isListItem, borderRadius
  } = props;

  const containerCx = classNames(
    className,
    'video-content',
    getSizeCx(containerSize),
    getAlignCx(containerAlign),
    {
      'is-list-item': isListItem,
    }
  );

  const videoBlockCx = classNames(
    'video-block',
    `is-${size}`
  );

  const videoCx = classNames(
    'video',
    'is-16by9',
    'has-shadow',
    'animate__animated animate__fadeIn animate__slow',
    getSizeCx(size),
    {
      'has-rounded-corners': !isPresent(borderRadius)
    }
  );

  const contentCx = classNames(
    'block',
    'mt-5',
    getAlignCx(align)
  );

  const videoStyles = (
    isPresent(borderRadius)
      ? { borderRadius: `${borderRadius}px` }
      : {}
  );

  return (
    <div className={containerCx}>
      <div className={videoBlockCx}>
        <div className={videoCx} style={videoStyles}>
          {
            url.match(/:\/\/iframe.mediadelivery.net\//)
            ? <iframe
                src={url}
                loading="lazy"
                style={{ border: 'none', position: 'absolute', top: 0, height: '100%', width: '100%' }}
                allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
                allowfullscreen="true"
              />
            : <VideoPlayer className="video-player" url={url} controls />
          }
        </div>
      </div>

      { (title || caption || subtitle || description)
          && (
            <div className={contentCx}>
              { isPresent(caption)     && <p className="title is-5">{caption}</p> }
              { isPresent(title)       && <p className="title is-4">{title}</p> }
              { isPresent(subtitle)    && <p className="subtitle is-5">{subtitle}</p> }
              { isPresent(description) && <Markdown source={description} />}
            </div>
          )
      }
    </div>
  );
};

export default VideoContent;
